@file:OptIn(InternalResourceApi::class)

package dev.jfronny.zerointerest.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/dev.jfronny.zerointerest.shared.generated.resources/"

@delegate:ResourceContentHash(-484_199_631)
internal val Res.string.transactions: StringResource by lazy {
      StringResource("string:transactions", "transactions", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5535, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4819, 36),
      ))
    }

@delegate:ResourceContentHash(-428_935_484)
internal val Res.string.unexpected_error_verification: StringResource by lazy {
      StringResource("string:unexpected_error_verification", "unexpected_error_verification", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5576, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4856, 105),
      ))
    }

@delegate:ResourceContentHash(-10_639_588)
internal val Res.string.unfavorite_room: StringResource by lazy {
      StringResource("string:unfavorite_room", "unfavorite_room", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5706, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4962, 39),
      ))
    }

@delegate:ResourceContentHash(-1_579_724_670)
internal val Res.string.upgrade_room: StringResource by lazy {
      StringResource("string:upgrade_room", "upgrade_room", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5754, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5002, 56),
      ))
    }

@delegate:ResourceContentHash(371_913_089)
internal val Res.string.use_access_token: StringResource by lazy {
      StringResource("string:use_access_token", "use_access_token", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5819, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5059, 48),
      ))
    }

@delegate:ResourceContentHash(-1_029_487_451)
internal val Res.string.username: StringResource by lazy {
      StringResource("string:username", "username", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5876, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5108, 28),
      ))
    }

@delegate:ResourceContentHash(-2_107_960_773)
internal val Res.string.verification_accepted: StringResource by lazy {
      StringResource("string:verification_accepted", "verification_accepted", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5909, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5137, 57),
      ))
    }

@delegate:ResourceContentHash(-211_489_954)
internal val Res.string.verification_cancelled: StringResource by lazy {
      StringResource("string:verification_cancelled", "verification_cancelled", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6081, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5301, 62),
      ))
    }

@delegate:ResourceContentHash(-2_015_524_988)
internal val Res.string.verification_cancelled_by: StringResource by lazy {
      StringResource("string:verification_cancelled_by", "verification_cancelled_by", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 5971, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5195, 105),
      ))
    }

@delegate:ResourceContentHash(951_128_127)
internal val Res.string.verification_in_progress: StringResource by lazy {
      StringResource("string:verification_in_progress", "verification_in_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6148, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5364, 64),
      ))
    }

@delegate:ResourceContentHash(1_055_891_238)
internal val Res.string.verification_request: StringResource by lazy {
      StringResource("string:verification_request", "verification_request", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6283, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5499, 56),
      ))
    }

@delegate:ResourceContentHash(-2_094_570_994)
internal val Res.string.verification_request_sent: StringResource by lazy {
      StringResource("string:verification_request_sent", "verification_request_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6209, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5429, 69),
      ))
    }

@delegate:ResourceContentHash(-1_695_209_666)
internal val Res.string.verification_successful: StringResource by lazy {
      StringResource("string:verification_successful", "verification_successful", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6340, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5556, 63),
      ))
    }

@delegate:ResourceContentHash(-834_389_636)
internal val Res.string.version_unknown: StringResource by lazy {
      StringResource("string:version_unknown", "version_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6408, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5620, 35),
      ))
    }

@delegate:ResourceContentHash(985_881_955)
internal val Res.string.waiting_for_other_device: StringResource by lazy {
      StringResource("string:waiting_for_other_device", "waiting_for_other_device", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6724, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5904, 64),
      ))
    }

@delegate:ResourceContentHash(-1_281_482_186)
internal val Res.string.waiting_for_other_device_accept: StringResource by lazy {
      StringResource("string:waiting_for_other_device_accept", "waiting_for_other_device_accept", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6444, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5656, 119),
      ))
    }

@delegate:ResourceContentHash(1_072_854_281)
internal val Res.string.waiting_for_other_device_finish: StringResource by lazy {
      StringResource("string:waiting_for_other_device_finish", "waiting_for_other_device_finish", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6584, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5776, 127),
      ))
    }

@delegate:ResourceContentHash(88_433_904)
internal val Res.string.you: StringResource by lazy {
      StringResource("string:you", "you", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 6789, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5969, 15),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("transactions", Res.string.transactions)
  map.put("unexpected_error_verification", Res.string.unexpected_error_verification)
  map.put("unfavorite_room", Res.string.unfavorite_room)
  map.put("upgrade_room", Res.string.upgrade_room)
  map.put("use_access_token", Res.string.use_access_token)
  map.put("username", Res.string.username)
  map.put("verification_accepted", Res.string.verification_accepted)
  map.put("verification_cancelled", Res.string.verification_cancelled)
  map.put("verification_cancelled_by", Res.string.verification_cancelled_by)
  map.put("verification_in_progress", Res.string.verification_in_progress)
  map.put("verification_request", Res.string.verification_request)
  map.put("verification_request_sent", Res.string.verification_request_sent)
  map.put("verification_successful", Res.string.verification_successful)
  map.put("version_unknown", Res.string.version_unknown)
  map.put("waiting_for_other_device", Res.string.waiting_for_other_device)
  map.put("waiting_for_other_device_accept", Res.string.waiting_for_other_device_accept)
  map.put("waiting_for_other_device_finish", Res.string.waiting_for_other_device_finish)
  map.put("you", Res.string.you)
}
